import { Table } from 'antd';
import dayjs from 'dayjs';
import { useSetRemainderLogQuery } from '../../../modules/Client/Client/api/endpoints/clientEndpoints';

const RemainderLog = ({ data }: { data: any }) => {
  const { data: singleData, isLoading } = useSetRemainderLogQuery(Number(data?.invoice_id));

  const columns = [
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (text: string) => dayjs(text).format('DD-MM-YYYY, hh:mm A'),
    },
    {
      title: 'Partial Amount',
      dataIndex: 'partial_payment_amount',
      key: 'partial_payment_amount',
    },
    {
      title: 'Partial Due Date',
      dataIndex: 'partial_due_date',
      key: 'partial_due_date',
      render: (text: string) => dayjs(text).format('DD-MM-YYYY'),
    },
    {
      title: 'Message',
      dataIndex: 'send_body',
      key: 'send_body',
    },
    {
      title: 'Send Date',
      dataIndex: 'send_date',
      key: 'send_date',
      render: (text: string) => dayjs(text).format('DD-MM-YYYY'),
    },

    {
      title: 'Send By',
      dataIndex: 'send_by_name',
      key: 'send_by_name',
    },
  ];

  return (
    <div>
      <h3 className='text-lg font-semibold mb-4'>Reminder Logs</h3>
      <Table
        bordered
        scroll={{ x: 'max-content' }}
        columns={columns}
        dataSource={singleData?.data || []}
        loading={isLoading}
        rowKey='id'
        pagination={false}
      />
    </div>
  );
};

export default RemainderLog;
